import { request } from "../../Services/Api"

export const getInvoices = (params) => request.api.get(`/payments/invoice-history/`, params)
export const reissueInvoice = (id) =>
  request.api.patch(`/payments/invoice-history/${id}/pay-out-of-band/`)

export const getInvoicesExport = ({ file_name, id, type, ...params }) => {
  if (type === "for_user") {
    return request.api.get(`/payments/invoice-history/export-invoice-history-user/`, params)
  } else if (type === "history") {
    return request.api.get(`/payments/invoice-history/${id}/export-alerts-by-invoice/`, params)
  } else {
    return request.api.get(`/payments/invoice-history/download-csv/`, params)
  }
}

export const updateInvoice = ({ id, type_request, ...data }) => {
  if (type_request === "all_invoices") {
    return request.api.patch(`/payments/invoice-history/${id}/update_status/`, data)
  } else {
    return request.api.post(`/shopify/shopify_charges/${id}/update_status/`, data)
  }
}

export const invoiceGenerating = ({ ...data }) =>
  request.api.post(`/payments/invoice-history/generate_weekly_invoice/`, data)

export const getInvoiceHistory = ({ id, ...params }) =>
  request.api.get(`/payments/invoice-history/${id}/get_alerts_by_invoice/`, params)

export const getInvoicesFilterOptions = (params) =>
  request.api.get(`/payments/invoice-history/filter_options`, params)

export const getInvoiceDownload = ({ file_name, invoice_id, type, format, ...params }) =>
  request.api.get(`/payments/invoice-history/${invoice_id}/download-pdf/`, params, {
    responseType: "blob"
  })

export const getInvoicesStatusOptions = (params) =>
  request.api.get(`/payments/invoice-history/status_options`, params)

export const updateInvoiceHistory = ({ id, ...data }) =>
  request.api.patch(`/payments/invoice-history/${id}/update_status/`, data)
